// import React, { useState, useEffect } from 'react';

// const Slideshow = ({ images, interval = 2500 }) => {
//     const [currentIndex, setCurrentIndex] = useState(0);

//     useEffect(() => {
//         if (images.length <= 1) return;

//         const timer = setInterval(() => {
//             setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
//         }, interval);

//         return () => clearInterval(timer);
//     }, [images.length, interval]);

//     // If only one image, don't animate
//     if (images.length === 1) {
//         return (
//             <div className='flex justify-center items-center h-[200px] sm:h-[300px] md:h-[400px] lg:h-[500px] w-[100%]'>
//                 <div className='h-[75%] w-[100%]'>
//                     <img
//                         src={images[0].url}
//                         alt={images[0].alt}
//                         className="w-full h-full object-contain"
//                     />
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className='flex justify-center items-center h-[200px] sm:h-[300px] md:h-[400px] lg:h-[500px] w-[100%]'>
//             <div className='h-[75%] w-[100%] relative'>
//                 {images.map((image, index) => (
//                     <img
//                         key={index}
//                         src={image.url}
//                         alt={image.alt}
//                         className={`w-full h-full object-contain absolute transition-opacity duration-1000 ${
//                             currentIndex === index ? 'opacity-100' : 'opacity-0'
//                         }`}
//                     />
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default Slideshow;






















// import React, { useEffect, useRef, useState } from 'react';

// const Slideshow = ({ images, interval = 4000 }) => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isHovered, setIsHovered] = useState(false);
//     const slideRef = useRef(null);

//     const extendedImages = [...images, images[0]];

//     useEffect(() => {
//         if (images.length <= 1 || isHovered) return;

//         const timer = setInterval(() => {
//             setCurrentIndex((prevIndex) => prevIndex + 1);
//         }, interval);

//         return () => clearInterval(timer);
//     }, [interval, images.length, isHovered]);

//     useEffect(() => {
//         const slide = slideRef.current;
//         if (!slide) return;

//         slide.style.transition = 'transform 1s ease-in-out';
//         slide.style.transform = `translateX(-${currentIndex * 100}%)`;

//         if (currentIndex === images.length) {
//             const reset = setTimeout(() => {
//                 slide.style.transition = 'none';
//                 slide.style.transform = 'translateX(0%)';
//                 setCurrentIndex(0);
//             }, 1000);

//             return () => clearTimeout(reset);
//         }
//     }, [currentIndex, images.length]);

//     return (
//         <div
//             className="w-full overflow-hidden h-[200px] sm:h-[300px] md:h-[400px] lg:h-[500px] flex justify-center items-center"
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//         >
//             <div
//                 ref={slideRef}
//                 className="flex h-[75%] w-full"
//                 style={{ width: `${extendedImages.length * 100}%` }}
//             >
//                 {extendedImages.map((image, index) => (
//                     <div key={index} className="w-full flex-shrink-0">
//                         <img
//                             src={image.url}
//                             alt={image.alt}
//                             className=" w-fit h-full object-contain rounded-2xl"
//                         />
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default Slideshow;




















import React, { useEffect, useRef, useState } from "react";

const Slideshow = ({ images, interval = 4000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const slideRef = useRef(null);

    const extendedImages = [...images, images[0]];

    useEffect(() => {
        if (images.length <= 1 || isHovered) return;

        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }, interval);

        return () => clearInterval(timer);
    }, [interval, images.length, isHovered]);

    useEffect(() => {
        const slide = slideRef.current;
        if (!slide) return;

        // Apply smooth transition
        slide.style.transition = "transform 2s ease-in-out";
        slide.style.transform = `translateX(-${currentIndex * 100}%)`;

        const handleTransitionEnd = () => {
            // If reached last image, jump to first
            if (currentIndex === images.length) {
                slide.style.transition = "none";
                slide.style.transform = "translateX(0%)";
                setCurrentIndex(0);
            }
        };

        slide.addEventListener("transitionend", handleTransitionEnd);

        return () => slide.removeEventListener("transitionend", handleTransitionEnd);
    }, [currentIndex, images.length]);

    return (
        <div
            className="w-full overflow-hidden   flex justify-center items-center"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div ref={slideRef} className="flex h-[75%] w-full" style={{ width: `${extendedImages.length * 100}%` }}>
                {extendedImages.map((image, index) => (
                    <div key={index} className="w-full flex-shrink-0">
                        <img src={image.url} alt={image.alt} className="mx-auto w-fit h-full object-contain rounded-2xl" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Slideshow;
























// import React, { useEffect, useRef, useState } from "react";

// const Slideshow = ({ images, interval = 4000 }) => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const slideRef = useRef(null);
//     const [isHovered, setIsHovered] = useState(false);

//     // Extend images to enable seamless looping
//     const extendedImages = [...images, images[0]];

//     useEffect(() => {
//         if (!images || images.length <= 1 || isHovered) return;

//         const timer = setInterval(() => {
//             setCurrentIndex((prevIndex) => prevIndex + 1);
//         }, interval);

//         return () => clearInterval(timer);
//     }, [interval, images, isHovered]);

//     useEffect(() => {
//         const slide = slideRef.current;
//         if (!slide) return;

//         // Apply slide transition
//         slide.style.transition = "transform 2s ease-in-out";
//         slide.style.transform = `translateX(-${currentIndex * (100 / extendedImages.length)}%)`;

//         const handleTransitionEnd = () => {
//             if (currentIndex === images.length) {
//                 slide.style.transition = "none";
//                 slide.style.transform = `translateX(0%)`;
//                 setCurrentIndex(0);
//             }
//         };

//         slide.addEventListener("transitionend", handleTransitionEnd);
//         return () => slide.removeEventListener("transitionend", handleTransitionEnd);
//     }, [currentIndex, images.length, extendedImages.length]);

//     return (
//         <div
//             className="w-full overflow-hidden relative"
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//         >
//             <div
//                 ref={slideRef}
//                 className="flex transition-all duration-2000 ease-in-out"
//                 style={{ width: `${extendedImages.length * 100}%` }}
//             >
//                 {extendedImages.map((image, index) => (
//                     <div
//                         key={index}
//                         className=" flex-shrink-0  h-[75%] w-full flex items-center justify-center"
//                         style={{ width: `${100 / extendedImages.length}%` }}
//                     >
//                         <img
//                             src={image.url}
//                             alt={image.alt || `slide-${index}`}
//                             className="w-fit h-full object-contain rounded-xl"
//                         />
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default Slideshow;
